//service
import request from '@/utils/request';
import { loginOrg } from '@/utils/LoginContext';

export async function queryPickareaGroup(payload) {
    return request(`/iwms-wms/wms/pickareagroup/query`, {
      method: 'POST',
      body: payload,
    });
}

export async function savePickareaGroup(payload) {
  return request(`/iwms-wms/wms/pickareagroup/save`, {
    method: 'POST',
    body: payload,
  });
}

export async function modifyPickareaGroup(payload) {
  return request(`/iwms-wms/wms/pickareagroup/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function deletePickareaGroup(payload) {
  return request(`/iwms-wms/wms/pickareagroup/remove/${payload.uuid}`, {
    method: 'DELETE',
  });
}

export async function getPickareaGroup(payload) {
  return request(`/iwms-wms/wms/pickareagroup/get?uuid=${payload}`, {
      method: 'GET',
  });
}

export async function getPickareaGroupByCode(payload) {
  return request(`/iwms-wms/wms/pickareagroup/getByCode?dcUuid=${loginOrg().uuid}&code=${payload.code}`, {
      method: 'GET',
  });
}

export async function queryBinOrderItem(payload) {
    return request(`/iwms-wms/wms/pickareagroup/queryBinOrderItem`, {
      method: 'POST',
      body: payload,
    });
}

export async function adjustBinOrderWithPickareaGroup(payload) {
  return request(`/iwms-wms/wms/pickareagroup/adjustBinOrder?groupUuid=${payload.groupUuid}&binCode=${payload.binCode}&newOrder=${payload.newOrder}`, {
      method: 'POST',
  });
}

export async function getBinOrderItemByUuid(payload) {
    return request(`/iwms-wms/wms/pickareagroup/getBinOrderItemByUuid?uuid=${payload}`, {
        method: 'GET',
    });
  }

